import { use, useEffect, useRef, useState } from 'react';
// import EditComponent from './GiftCardEdit';
import { Button, Col, DatePicker, Form, Popover, Row, Select, Space, Table, Tooltip } from 'antd';
import fetchApi from '../../../utils/api/fetchApi';
import system from '../../../config/systematic';
import getList from '../../universal/getList';
import antMessage from '../../../utils/extend/AntdNotification'
import moment from 'moment';
import DownloadExcel from '../../report/DownloadExcel';
const { RangePicker } = DatePicker;

export default function WriteOffGiftCardReport() {
  const wmService: any = system.wmService;
  const [giftCardStatus, setGiftCardStatus] = useState<any>();
  const [usageShop, setUsageShop] = useState<Array<any>>([]);
  const [rows, setRows] = useState<Array<any>>([]);
  const [branchStoreName, setBranchStoreName] = useState<string>("所有");
  const [giftCardStatusName, setGiftCardStatusName] = useState<string>("已核销");
  let [userName, setUserName] = useState<string>("")
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const [form] = Form.useForm();
  //表头
  const columnsHead = [
    {
      title: '排序',
      dataIndex: 'serial',
      key: "serial",
      width: 10,
      header: "排序",
    },
    {
      title: '方案',
      dataIndex: 'planName',
      key: "planName",
      width: 30,
      header: "方案",
    },
    {
      title: '次数',
      dataIndex: 'counts',
      key: "counts",
      width: 15,
      header: "次数",
    },
    {
      title: '购入价',
      dataIndex: 'salePrice',
      key: "salePrice",
      width: 20,
      header: "购入价",
    },
    {
      title: '优惠价',
      dataIndex: 'discount',
      key: "discount",
      width: 20,
      header: "优惠价",
    },
    {
      title: '面值',
      dataIndex: 'faceValue',
      key: "faceValue",
      width: 20,
      header: "面值",
    },

  ];
  useEffect(() => {
    fetchApi.GET(wmService, {
      apiId: "generalData",
      apiExtend: 'bms',
      apiData: {
        apiId: 'generalData',
        apiExtend: 'showList',
        apiVariable: 'giftCardStatus',
      }
    }).then(res => {
      if (res.success) {
        setGiftCardStatus(res.data)
      }
    }).catch((err) => {
      console.log("err", err);
    })
    fetchApi.GET(
      wmService,
      {
        apiId: "branchStore",
        apiExtend: 'showListManage'
      }
    ).then(res => {
      if (res.success) {
        setUsageShop(res.data);
      }
    })
    form.setFieldValue("giftCardStatusIds", [2])
  }, []);

  const onFinish = () => {

    setIsLoading(true)
    form.validateFields()
      .then(async (values: any) => {

        fetchApi.GET(wmService, {
          apiId: "giftCard",
          apiExtend: 'writeOffGiftCardReport',
          apiData: {
            ...values,
            // branchStoreId
          }
        }).then((res) => {
          setIsLoading(false)
          if (res.success) {

            setRows(res.data)
            setUserName(res.userName)
          }
        }).catch((err) => {
          setIsLoading(false)
          antMessage("error", "失败", err.message)
        })

      })
      .catch((err) => {
        setIsLoading(false)
        antMessage("error", "失败", JSON.stringify(err))

      })

  }
  const changedGiftCardStatus = (e: any, option: any) => {
    let giftCardStatusName: Array<any> = []
    for (let i = 0; i < option?.length; i++) {
      giftCardStatusName.push(option[i].children)
    }


    setGiftCardStatusName(giftCardStatusName.join(","))

  }
  const changedBranchStore = (e: any, option: any) => {
    let branchStoreName: Array<any> = []
    for (let i = 0; i < option?.length; i++) {
      branchStoreName.push(option[i].children)
    }


    setBranchStoreName(branchStoreName.join(","))

  }
  return (
    <div>
      <Form form={form} initialValues={{ dataStatusType: 1 }} onFinish={onFinish}>
        <Row>
          <Col span={12}>

            <Form.Item
              name="usageDate"
              label="使用日期"
            >
              <RangePicker
                allowClear
                // defaultValue={moment(data.bookingDate)}
                format="YYYY-MM-DD"
              />
            </Form.Item>
          </Col>


          <Col span={12}>

            <Form.Item
              name="giftCardStatusIds"
              label="礼品卡状态"

            >
              <Select
                allowClear
                onChange={changedGiftCardStatus}
                // style={{ width: "300px" }}
                // orderTypeData
                mode="multiple"
                showSearch
                placeholder="请选择状态!"
                optionFilterProp="children"

                filterOption={(input, option: any) => {
                  return true
                }}
              >
                {getList.general(giftCardStatus, 'name')}
              </Select>
            </Form.Item>
          </Col>

          <Col span={12}>

            <Form.Item
              name="branchStoreIds"
              label="核销门店"
            >
              <Select
                allowClear
                onChange={changedBranchStore}
                // style={{ width: "300px" }}
                // orderTypeData
                mode="multiple"
                showSearch
                placeholder="请选择状态!"
                optionFilterProp="children"

                filterOption={(input, option: any) => {
                  return true
                }}
              >
                {getList.general(usageShop, 'branchStoreName')}
              </Select>
            </Form.Item>
          </Col>


          <Col span={4}>
            <Form.Item >
              <Space>
                <Button loading={isLoading} htmlType="submit">
                  统计
                </Button >
                {/* <Button onClick={() => DownloadExcel(rows, "billQuery", { columnsHead })}>下载EXCEL文件</Button> */}
                <Button onClick={() => DownloadExcel(rows, "writeOffGiftCardReport", { columnsHead, branchStoreName, giftCardStatusName, userName, date: form.getFieldValue("usageDate") })}>下载EXCEL文件</Button>
                {/* purContrast */}
              </Space>
            </Form.Item>
          </Col>

        </Row>
      </Form>

      <div style={{ marginTop: "20px" }}>
        <Table
          scroll={{ x: "100%", y: 950 }}
          pagination={false}
          // rowKey={(record: any, index: any) => {
          //     return index
          // }}
          columns={columnsHead}
          dataSource={rows}

        >
        </Table>

      </div>
    </div>


  )
}
